import { Text, VStack } from "@chakra-ui/layout";
import { Box } from "@chakra-ui/react";

import { UUID } from "foundation-ts/types";
import { $count, $isuuid, $ok } from "foundation-ts/commons";
import { SessionDto, UserDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";
import { LockedAccount, UserProfile } from "@bcasmart/doxecure-commons/doxecureTypes";

import { ColumnTitle } from "@components/ColumnTitle/ColumnTitle";
import { G1Button } from "@components/G1Button";
import { config } from "@/config/config";
import { SignatureBox } from "@containers/signature/SignatureBox";
import { $g1Color } from "@/theme/G1Style";
import { NeededPersonRole } from "@utils/TypesAndConstants";


// TODO: do we keep openFailModal here ?
interface TemplateSessionCreationPanelProps {
    session: SessionDto;
    userProfile: UserDto;
    optionAddApproversSwitchChecked?: boolean;
    optionAddRecipientsSwitchChecked?: boolean;
    optionInvisibleSwitchChecked?: boolean;
    optionOneToManyModeSwitchChecked?: boolean;
    lockedAccount?: LockedAccount;
    onAddUser: (role: NeededPersonRole) => void;
    onChangeSession: (oldSession:SessionDto, newSession:SessionDto) => void;
    onRemoveUser: (apid: UUID, role: NeededPersonRole) => void;
    onSaveTemplate: () => void;
    onToggleAddApproversSwitch: () => void;
    onToggleAddRecipientsSwitch: () => void;
    onToggleInvisibleSwitch: () => void;
    onToggleOneToManyModeSwitch: () => void;
}

export const TemplateSessionCreationPanel = (props: TemplateSessionCreationPanelProps) => {
    const { 
        session,
        userProfile,
        optionAddApproversSwitchChecked,
        optionAddRecipientsSwitchChecked,
        optionInvisibleSwitchChecked,
        optionOneToManyModeSwitchChecked,
        lockedAccount,
        onAddUser,
        onChangeSession,
        onRemoveUser,
        onSaveTemplate,
        onToggleAddApproversSwitch,
        onToggleAddRecipientsSwitch,
        onToggleInvisibleSwitch,
        onToggleOneToManyModeSwitch
    } = props;
    const isSessionValid = $isuuid(session.expeditor.apid) && $count(session.signatures) > 0 && session.title.length > 0;

    const boxDirection = { base: "column", sm: "row" } as const;
    const fullWidth = { base: "100%", sm: "30%" } as const;
    const marginLeft = { base: "unset", sm: "2%" } as const;

    const SaveButton = () => (
        <G1Button component="form" variant="important" title={$ok(session.apid) ? 'Mettre à jour' : 'Créer'} width={fullWidth} height="60px" marginLeft={marginLeft} rounded="xl" fontSize="lg"
                  disabled={lockedAccount?.exceedsUsersLimit || lockedAccount?.canceledAndWaitingSessionEnds || !isSessionValid} onClick={onSaveTemplate} />
    );

    return (
        <>
            <ColumnTitle color={$g1Color('global.write')}>
                <Text>Création / Edition d'un modèle</Text>
            </ColumnTitle>

            <VStack spacing="5">
                <SignatureBox
                    session={session}
                    displayDuringTime={true}
                    enableAddApproversOption={config.app.nbMaxApprovers !== 0 && (userProfile.userFlags?.profile === UserProfile.AdministratorCorporate || userProfile.userFlags?.profile === UserProfile.UserCorporate)}
                    enableAddRecipientsOption={config.app.nbMaxRecipients !== 0}
                    optionAddApproversSwitchChecked={optionAddApproversSwitchChecked}
                    optionAddRecipientsSwitchChecked={optionAddRecipientsSwitchChecked}
                    optionInvisibleSwitchChecked={optionInvisibleSwitchChecked}
                    optionOneToManyModeSwitchChecked={optionOneToManyModeSwitchChecked}
                    onAddUser={onAddUser}
                    onRemoveUser={onRemoveUser}
                    onChangeSession={onChangeSession}
                    onToggleAddApproversSwitch={onToggleAddApproversSwitch}
                    onToggleAddRecipientsSwitch={onToggleAddRecipientsSwitch}
                    onToggleInvisibleSwitch={onToggleInvisibleSwitch}
                    onToggleOneToManyModeSwitch={onToggleOneToManyModeSwitch}
                />
                <Box display="flex" flexDirection={boxDirection} width="100%" gap="10px" justifyContent="center">
                    <SaveButton />
                </Box>
            </VStack>
        </>
    );
};